import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import DepositManagerTabs from './DepositManagerTabs';
import { useTheme } from '@emotion/react';

const Warning = ({ matchessm }) => {
  return (
    <svg
      width={matchessm ? '28' : '38'}
      height={matchessm ? '27' : '37'}
      viewBox="0 0 38 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.5"
        width="37.5797"
        height="36"
        rx="18"
        fill="#F39800"
        fill-opacity="0.25"
      />
      <path
        d="M27.0817 21.9607L21.3085 11.956C20.7883 11.0551 19.8271 10.5 18.7866 10.5C17.7462 10.5 16.7851 11.0551 16.2648 11.956L10.3902 22.132C9.86994 23.0329 9.86994 24.1431 10.3902 25.044C10.9104 25.9449 11.8715 26.5 12.912 26.5H24.6614C24.6646 26.5 24.6677 26.5 24.6677 26.5C26.276 26.5 27.5797 25.1962 27.5797 23.588C27.5797 22.9853 27.3957 22.4239 27.0817 21.9607ZM20.0333 22.9345C20.0333 23.6229 19.5036 24.1495 18.7898 24.1495C18.0761 24.1495 17.5464 23.6229 17.5464 22.9345V22.906C17.5464 22.2208 18.0761 21.6911 18.7898 21.6911C19.5036 21.6911 20.0333 22.2177 20.0333 22.906V22.9345ZM20.0619 14.7443L19.4465 20.1178C19.4052 20.5048 19.1483 20.7458 18.7898 20.7458C18.4314 20.7458 18.1745 20.5016 18.1332 20.1178L17.5178 14.7411C17.4766 14.3255 17.7019 14.0115 18.0888 14.0115H19.4877C19.8747 14.0147 20.1031 14.3287 20.0619 14.7443Z"
        fill="#F39800"
      />
    </svg>
  );
};

const DepositManagerPopup = (props) => {
  const {
    openDepositManager,
    handleClosedeposit,
    profileDetails,
    getListInfo,
    manageOfferClick,
    fromVendorStatus,
  } = props;

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const Address = profileDetails?.PropertyDetails?.propertyAddress?.streetName;

  return (
    <>
      <Dialog
        onClose={handleClosedeposit}
        // maxWidth={"lg"}
        // fullWidth
        open={openDepositManager}
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              scrollbarWidth: 'none',
              borderRadius: '8px',
              maxWidth: '1219px',
            },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <Box
            sx={{
              fontFamily: 'poppins',
              fontWeight: 400,
              fontSize: matchessm ? '12px' : '14px',
              color: '#666666',
            }}
          >
            {Address}
          </Box>
          <Stack
            flexDirection={'row'}
            alignItems={'center'}
            gap={1.5}
            sx={{
              fontFamily: 'poppins',
              fontWeight: 500,
              fontSize: matchessm ? '18px' : '24px',
              mt: 1,
            }}
          >
            {' '}
            <Warning matchessm={matchessm} />
            Deposit Manager
          </Stack>
        </DialogTitle>
        <DialogContent
          sx={{
            p: {
              xs: 0.5, // extra padding for mobile (theme.spacing(3) = 24px)
              sm: 2, // normal/default padding for tablets and up
            },
          }}
        >
          {/* <Box> */}
          <DepositManagerTabs
            handleClosedeposit={handleClosedeposit}
            profileDetails={profileDetails}
            getListInfo={getListInfo}
            manageOfferClick={manageOfferClick}
            fromVendorStatus={fromVendorStatus}
          />
          {/* </Box> */}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DepositManagerPopup;
